import { useMutation, useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { Alert } from "components/base/Toast";
import moment from "moment";
import {
  UPDATE_PRODUCTION_PLAN_STATE,
  VALIDATE_PRODUCTION_PLAN,
} from "./graphql";
import BomsView from "./validatePlan/BomsView";
import RoutesView from "./validatePlan/RoutesView";
import SOPOView from "./validatePlan/SOPOView";

const ConfirmPlanView = ({ plan, didConfirmTime }) => {
  const { loading, error, data } = useQuery(VALIDATE_PRODUCTION_PLAN, {
    variables: { planId: plan.id },
    fetchPolicy: "network-only",
  });
  const [confirm, confirmRes] = useMutation(UPDATE_PRODUCTION_PLAN_STATE, {
    variables: { id: plan.id, action: "CONFIRM_TIME" },
    onCompleted() {
      Alert("success", "Plan time confirmed");
      didConfirmTime();
    },
    onError(error) {
      Alert("error", error.message);
    },
  });

  if (loading) return <Spinner text="Validating Production Plan..." />;
  if (error) return <Errors error={error} />;

  const res = JSON.parse(data.validateProductionPlan);

  console.log("ConfirmPlanView.plan", plan, res);

  return (
    <div className="text-sm space-y-8">
      <RoutesView routes={res.routes} />
      <BomsView boms={res.boms} />
      <SOPOView errors={res.so_po_errors} />

      <div>
        <div className="leading-relaxed">
          <div>
            You are going to confirm the time for plan: <b>{plan.name}</b>, the
            estimate ready date is :{" "}
            <b>{moment(plan.readyDate).format("YYYY-MM-DD")}</b>.
          </div>

          {plan.parent && (
            <div>
              <p>
                This is an additional plan, once you confirm the time, it will
                change to handled stage.
              </p>
              <p>
                You will need to sync to odoo after confirm an additional plan.
              </p>
              <p>
                Sync in additional plan will auto change the state to
                `PROCESSING` so that it inventory will be unlock immediately.
              </p>
            </div>
          )}

          <div>Are you sure to confirm the time for this plan?</div>
        </div>

        <hr />

        <div>
          <Button primary onClick={confirm} loading={confirmRes.loading}>
            Confirm Time
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPlanView;
